class ComponentRegistery {

    constructor() {
        this.components = {};
        this.stores = {};
        this.storeGenerators = {};
    }

    register(component) {
        this.components = Object.assign(this.components, component);
    }

    registerStore(store) {
        this.storeGenerators = Object.assign(this.storeGenerators, store);
    }

    initializeStore(name, initialValue) {
        this.stores[name] = this.storeGenerators[name](initialValue);
    }

    get(name) {
        return this.components[name];
    }

    getStore(name) {
        return this.stores[name];
    }
}

const instance = new ComponentRegistery();

export default instance;



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/ComponentRegistry.jsx